import { FaCheck } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import CircularProgressBar from "../../Common/CircularProgressBar";
import { useEffect, useState } from "react";
import { DivideData, EstateBeneficiarySetList } from "../../api/get";
import { SaveEstateDevidedData } from "../../api/api";
import toast from "react-hot-toast";
import Loader from "../../loader";
import Header from "../../Common/Header";
import Spinner from "../../Common/Spinner";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Toaster } from "react-hot-toast";
import { handleApiError } from "../../Common/Helper";
const SplitEstate = () => {
  const [selectedCharityData, setSelectCharityData] = useState([]);
  const [selectedBeneficiary, setSelectBeneficiary] = useState([]);
  const [EstateBeneficiaryData, setEstateBeneficiary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [devideValue, setDevideValue] = useState(0);
  const [percentages, setPercentages] = useState(
    Array(selectedCharityData.length).fill("0")
  );
  const [contentLoader, setContentLoader] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    // Fetch personal details and relationships and set form values once loaded
    Promise.all([DivideData(), EstateBeneficiarySetList()])
      .then(([DivideData, EstateBeneficiary]) => {
        if (
          DivideData.success &&
          EstateBeneficiary.success &&
          DivideData.status_code === "200" &&
          EstateBeneficiary.status_code === "200"
        ) {
          setSelectCharityData(DivideData.data.selectedCharities);
          setSelectBeneficiary(DivideData.data.selectedBeneficiaries);
          setEstateBeneficiary(EstateBeneficiary.data);
          setContentLoader(false);
        } else if (!DivideData.success) {
          handleApiError(DivideData, navigate); // Use helper function
        } else if (
          !EstateBeneficiary.success
        ) {
          handleApiError(EstateBeneficiary, navigate); // Use helper function
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  }, []);
  const calculateDevideValue = (values) => {
    const totalCharity = values.save_charities.reduce(
      (sum, charity) => sum + Number(charity.charity_percentage || 0),
      0
    );
    const totalBeneficiary = values.save_beneficiaries.reduce(
      (sum, beneficiary) =>
        sum + Number(beneficiary.beneficiary_percentage || 0),
      0
    );
    return totalCharity + totalBeneficiary;
  };
  // console.log("selectedBeneficiary =>", selectedBeneficiary);
  // console.log("selectedCharityData =>", selectedCharityData);
  const validationSchema = Yup.object().shape({
    save_charities: Yup.array().of(
      Yup.object().shape({
        charity_id: Yup.number().required("Charity ID is required"),
        charity_percentage: Yup.number()
          .required("Percentage is required")
          .min(0, "Percentage cannot be less than 0")
          .max(100, "Percentage cannot exceed 100"),
      })
    ),
    save_beneficiaries: Yup.array().of(
      Yup.object().shape({
        beneficiary_id: Yup.number().required("Beneficiary ID is required"),
        beneficiary_percentage: Yup.number()
          .required("Percentage is required")
          .min(0, "Percentage cannot be less than 0")
          .max(100, "Percentage cannot exceed 100"),
      })
    ),
  });

  const formik = useFormik({
    initialValues: {
      save_charities: selectedCharityData.map((charity) => ({
        charity_id: charity.charity_id,
        charity_percentage: charity.charity_percentage || "",
      })),
      save_beneficiaries: selectedBeneficiary.map((beneficiary) => ({
        beneficiary_id: beneficiary.beneficiary_id,
        beneficiary_percentage: beneficiary.beneficiary_percentage || "",
      })),
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      console.log("values =>", values);
      SaveEstateDevidedData(values) // Replace this function with your API call function
        .then((res) => {
          // toast.success("Estate divided successfully");
          if (EstateBeneficiaryData[0]?.beneficiary_id) {
            navigate(
              `/make-will-online/estate/inheritance/${EstateBeneficiaryData[0]?.id}`
            );
          } else {
            navigate("/dashboard");
          }
        })
        .catch((err) => {
          toast.error("An error occurred while saving the data.");
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });
  useEffect(() => {
    setDevideValue(calculateDevideValue(formik.values));
  }, [formik.values]);

  // Check if all fields are filled and if the total value is 100
  const isFormValid = () => {
    const allFieldsFilled =
      formik.values.save_charities.every(
        (charity) =>
          charity.charity_percentage !== "" && charity.charity_percentage !== 0
      ) &&
      formik.values.save_beneficiaries.every(
        (beneficiary) =>
          beneficiary.beneficiary_percentage !== "" &&
          beneficiary.beneficiary_percentage !== 0
      );

    return allFieldsFilled && devideValue === 100;
  };

  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Toaster />
          <div className="container charity-wrapper">
            <div className="grid grid-cols-2 max-lg:grid-cols-1 mt-[30px]">
              <div>
                <p className="font-semibold text-[20px] sm:text-[26px] lg:text-[30px]">
                  Divide your estate
                </p>
                <p className="my-3 text-slate-500">
                  Your estate is made up of everything you own. It includes bank
                  accounts, your home, stocks and shares, ISAs and any personal
                  belongings.
                </p>

                <h4 className="font-semibold text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] xl:text-[28px] mt-[25px]">
                  How would you like to split your estate?
                </h4>
                <p className="text-slate-500">
                  Make sure that the percentages you leave add up to 100%.
                </p>
                <form onSubmit={formik.handleSubmit}>
                  {formik.values.save_charities.map((charity, index) => (
                    <div className="flex" key={index}>
                      <div className="border-2 p-5 my-5 Heading w-full">
                        <div className="">
                          <div className="gap-[20px] flex items-center">
                            <div className="w-[15%] max-w-[100px]">
                              <img
                                src={selectedCharityData[index].charity_image}
                                alt="Charity"
                                className="w-full h-auto object-cover rounded-md"
                              />
                            </div>
                            <div className="w-[55%]">
                              <p className="font-bold text-[16px]">
                                {selectedCharityData[index].charity_name}
                              </p>
                              <p className="text-[14px]">
                                {selectedCharityData[index].charity_desc}
                              </p>
                            </div>
                            <div className="w-[30%] sm:w-[50%] md:w-[30%] border-l-4 border-primary pl-3">
                              <div className="flex items-center gap-2 relative">
                                {/* <label className="font-medium text-[14px]">
                                  Amount:
                                </label> */}
                                <input
                                  type="text"
                                  name={`save_charities[${index}].charity_percentage`}
                                  placeholder=""
                                  className="px-1 py-1 outline-none text-center rounded-md text-sm w-20 h-[70px] pr-6"
                                  value={
                                    formik.values.save_charities[index]
                                      .charity_percentage
                                  }
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      formik.setFieldValue(
                                        `save_charities[${index}].charity_percentage`,
                                        value
                                      );
                                    }
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <span className="absolute right-1.5 md:right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm md:text-base">
                                  %
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {formik.values.save_beneficiaries.map(
                    (beneficiary, index) => (
                      <div className="flex " key={index}>
                        <div className="border-2 p-5 my-5 Heading w-full">
                          <div className="">
                            <div className="gap-[20px] flex items-center">
                              <div className="w-[15%] max-w-[100px]">
                                <img
                                  src="/assets/images/icon-mascot.png"
                                  alt="Beneficiary"
                                  className="w-full h-auto object-cover rounded-md"
                                />
                              </div>
                              <div className="w-[55%]">
                                <p className="font-bold">
                                  {
                                    selectedBeneficiary[index]
                                      .beneficiary_first_name
                                  }{" "}
                                  {
                                    selectedBeneficiary[index]
                                      .beneficiary_last_name
                                  }
                                </p>
                                <p>Beneficiary </p>
                              </div>
                              <div className="w-[30%] sm:w-[50%] md:w-[30%] border-l-4 border-primary pl-3">
                                <div className="flex items-center relative">
                                  {/* <label className="font-medium">Amount:</label> */}
                                  <input
                                    type="text"
                                    name={`save_beneficiaries[${index}].beneficiary_percentage`}
                                    placeholder=""
                                    className="px-1 py-1 text-center outline-none rounded-md text-sm w-20 h-[70px] pr-6"
                                    value={
                                      formik.values.save_beneficiaries[index]
                                        .beneficiary_percentage
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        formik.setFieldValue(
                                          `save_beneficiaries[${index}].beneficiary_percentage`,
                                          value
                                        );
                                      }
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <span className="absolute right-1.5 md:right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm md:text-base">
                                    %
                                  </span>
                                  {/* <span>%</span> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                  <div className="flex justify-between items-center my-5 w-full gap-5 flex-nowrap">
                    <div className="text-sm md:text-base">
                      Remaining to allocate:{" "}
                      <span className="font-bold">{100 - devideValue}%</span>
                    </div>
                    <div className="flex items-center text-sm md:text-base">
                      <p className="mr-2">Allocated:</p>
                      <div className="relative">
                        <input
                          name="allocated_percentage"
                          type="text"
                          className="border-2 px-2 py-1 w-20 text-center"
                          value={devideValue}
                          readOnly
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500">
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between mb-5">
                    <Link to={"/make-will-online/estate/charity/standard"}>
                      <button
                        type="button"
                        className="flex items-center justify-center gap-1 text-[20px] py-2 rounded-[10px] text-slate-500"
                      >
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                    <button
                      onClick={() => {
                        setLoading(true);
                      }}
                      disabled={!isFormValid()}
                      type="submit"
                      className={`bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2 ${
                        !isFormValid() ? "cursor-not-allowed opacity-50" : ""
                      }`}
                    >
                      {loading ? <Spinner /> : "Next"}{" "}
                      {!loading ? <FaChevronRight /> : ""}
                    </button>
                  </div>
                </form>
              </div>

              <div>
                <div className="max-lg:hidden bg-no-repeat ">
                  <div className="fixed top-[300px] w-[500px] right-[6%]">
                    {/* <img src="/assets/images/9.png" alt="mascot" /> */}
                    <CircularProgressBar
                      progress={devideValue}
                      size={300}
                      strokeWidth={20}
                      circleColor="#d1d5db"
                      progressColor="#240642"
                      textColor="#374151"
                      fontSize="text-2xl"
                      fontWeight="font-bold"
                      duration={500}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SplitEstate;
